export default  {	
	data () {
		return { 
			cardCol: 8,
			cardCol2: 4,
			active: 0, 
		}
	},
	created () { 
		this.updateCrud({state:'namePath', data: 'paciente_registrar'}) 
	},
	destroyed()
	{		
		this.updateCrud({ state: 'searchSw/value', data: ''})
	}
}
